export const loadImageAsDataUrl = async (url: string): Promise<string> => {
    const response = await fetch(url, { mode: 'cors' });
    const blob = await response.blob();
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result as string);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
    });
};

export const fixBorderImageForScreenshot = async (root: HTMLElement): Promise<void> => {
    const allElements = Array.from(root.querySelectorAll<HTMLElement>('*'));
    const promises: Promise<void>[] = [];

    allElements.forEach((el) => {
        const style = window.getComputedStyle(el);

        const borderImageSource = style.borderImageSource;
        if (!borderImageSource || borderImageSource === 'none') return;

        const borderTopWidth = parseFloat(style.borderTopWidth) || 0;
        const borderRightWidth = parseFloat(style.borderRightWidth) || 0;
        const borderBottomWidth = parseFloat(style.borderBottomWidth) || 0;
        const borderLeftWidth = parseFloat(style.borderLeftWidth) || 0;
        if (!borderTopWidth && !borderRightWidth && !borderBottomWidth && !borderLeftWidth) return;

        const urlMatch = borderImageSource.match(/url\(['"]?(.+?)['"]?\)/);
        if (!urlMatch) return;

        const imageUrl = urlMatch[1];

        const promise = loadImageAsDataUrl(imageUrl)
            .then((dataUrl) => {
                const existingBgImage = style.backgroundImage !== 'none' ? style.backgroundImage : null;

                const bgImages = existingBgImage
                    ? `url('${dataUrl}'), ${existingBgImage}`
                    : `url('${dataUrl}')`;
                const bgOrigins = existingBgImage ? 'border-box, padding-box' : 'border-box';
                const bgClips = existingBgImage ? 'border-box, padding-box' : 'border-box';
                const bgSizes = existingBgImage
                    ? `100% 100%, ${style.backgroundSize || 'auto'}`
                    : '100% 100%';

                el.style.setProperty('background-image', bgImages, 'important');
                el.style.setProperty('background-origin', bgOrigins, 'important');
                el.style.setProperty('background-clip', bgClips, 'important');
                el.style.setProperty('background-size', bgSizes, 'important');
                el.style.setProperty('background-repeat', 'no-repeat', 'important');
                el.style.setProperty('border-image', 'none', 'important');
            })
            .catch(() => {});

        promises.push(promise);
    });

    await Promise.all(promises);
};
